import { Alert } from "../Alert";
import { AnimatePresence, motion } from "motion/react";
import { PulsingGreeter } from "./PulsingGreeter";
import { useRef } from "react";
import css from "./Spinner.module.scss";
import { Ellipsis } from "./Ellipsis";

export type NonBlockingSpinnerProps = {
  reason?: string | false;
  position?: "bottom-left" | "bottom-right";
};

export function NonBlockingSpinner(props: NonBlockingSpinnerProps) {
  const el = useRef<HTMLDivElement>(null);
  return (
    <AnimatePresence>
      {!!props.reason && (
        <motion.div
          ref={el}
          key={props.reason}
          style={{
            right: props.position === "bottom-right" ? 0 : undefined,
            left: props.position === "bottom-left" ? 0 : undefined,
          }}
          initial={{
            opacity: 0,
            bottom: 0,
            filter: "blur(5px)",
            position: "absolute",
          }}
          animate={{
            opacity: 1,
            bottom: 10,
            filter: "blur(0px)",
          }}
          exit={{
            opacity: 0,
            bottom: 0,
            filter: "blur(5px)",
          }}
        >
          <AnimatePresence mode="popLayout">
            <Alert key="alert">
              <AnimatePresence mode="popLayout">
                <motion.div
                  key="loading"
                  layout="position"
                  className={css.LogoContainer}
                  initial={{ x: -20, opacity: 0, filter: "blur(5px)" }}
                  animate={{ x: 0, opacity: 1, filter: "blur(0)" }}
                  exit={{ x: -20, opacity: 0, filter: "blur(5px)" }}
                >
                  <PulsingGreeter />
                </motion.div>
                {!!props.reason && (
                  <motion.div
                    key={
                      props.reason.trim().length > 0
                        ? props.reason
                        : "Bip bup bip"
                    }
                    layout="position"
                    initial={{ y: -30, filter: "blur(5px)", opacity: 0 }}
                    animate={{ y: 0, filter: "blur(0)", opacity: 1 }}
                    exit={{ y: 30, filter: "blur(5px)", opacity: 0 }}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "end",
                      gap: 3,
                    }}
                    className={css.Reason}
                  >
                    {props.reason.trim().length > 0 ? (
                      <>
                        {props.reason} <Ellipsis />
                      </>
                    ) : (
                      <>"Bip bup bip"</>
                    )}
                  </motion.div>
                )}
              </AnimatePresence>
            </Alert>
          </AnimatePresence>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
